import { Directive, HostListener, Input } from '@angular/core';
import { AuditService } from 'ngx-web-api';

@Directive({
  selector: '[ftsAuditableTextControl]',
})
export class AuditableTextControlDirective {
  @Input()
  auditName: string;

  constructor(private auditService: AuditService) {}

  @HostListener('focusout', ['$event.target'])
  onLostFocus(control: HTMLTextAreaElement | HTMLInputElement) {
    if (control.classList.contains('ng-dirty')) {
      this.auditService.createAudit(() => `${this.auditName} set to: "${control.value}"`);
    }
  }
}
